import type {parsePaymentPlan} from '../payment';

import {getPriceString} from '../../../money';
import {FULL_PORTION} from './constants';

export const getPortionPriceString = (
  portion: number,
  parsedPaymentPlan: ReturnType<typeof parsePaymentPlan>,
) => {
  const {parsedCurrency, total} = parsedPaymentPlan;

  return getPriceString({
    currency: parsedCurrency,
    intZeroPrice: true,
    price: Math.round(total * (portion / FULL_PORTION)),
  });
};
